/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'upload': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M9.56 13.088a.5.5 0 101 0v-9.38l3.557 3.558a.5.5 0 00.707-.707l-4.39-4.39a.499.499 0 00-.732-.018L5.294 6.559A.5.5 0 006 7.266L9.56 3.707v9.381zM3 13.471a.5.5 0 01.5.5v1.765c0 .698.566 1.264 1.265 1.264h10.588c.698 0 1.265-.566 1.265-1.264V13.97a.5.5 0 011 0v1.765A2.265 2.265 0 0115.353 18H4.765A2.265 2.265 0 012.5 15.736V13.97a.5.5 0 01.5-.5z" _fill="#3E424C"/>'
  }
})
